export interface Configuration {
    azStoreConfig:{
        index: string;
        queryKey: string;
        service: string;
        appinsights_Instrumentationkey: string
    }
    myMedia: {
        webComponentUrl: string,
        baseUrl: string,
        companyRelationsApiUrl: string,
    },
    identityServer: {
        authority: string,
        clientId: string,
        scope: string,
        clientSecret: string
    },
    marketingAndSalesTool: {
        myAccountLink: string,
        myBusinessLink: string
    }
}

const getConfigurationService =  async () => {
    const apiUrl = window.location.protocol + '//' + window.location.host + '/api/configuration'; 

    return await  fetch(apiUrl)
                  .then(res => res.json())
                  .then((data:any) => {
                          return <Configuration>data;
                  });
}

export default getConfigurationService